import styled from 'styled-components';
import { Container } from '../../../../../../stories/atoms';

export const FlexRow = styled.div`
  display: flex;
`;

export const FlexColumn = styled(FlexRow)`
  display: flex;
  flex-direction: column;
`;

export const StyledModalWrapper = styled(Container)<{ isMobile: boolean }>`
  padding: ${({ theme: { spacing }, isMobile }) => (isMobile ? spacing(8, 4) : spacing(8))};
`;

export const ChartContainer = styled(FlexColumn)`
  flex: 1;
  min-height: ${({ theme: { spacing } }) => spacing(62)};
`;

export const IconContainer = styled.div<{ isMobile: boolean }>`
  padding: ${({ theme: { spacing } }) => spacing(2)};
  & > div {
    width: ${({ theme: { spacing }, isMobile }) => (isMobile ? spacing(8) : spacing(12))};
    height: ${({ theme: { spacing }, isMobile }) => (isMobile ? spacing(8) : spacing(12))};
  }
`;
